export interface AuthInfo {
  token: string;
  refreshToken: string;
}
